// import React, { useEffect, useRef, useState } from "react";
// import { Form, Select, Button, DatePicker, Radio, Input, Spin } from "antd";
// import {

//   mobilePattern,
//   emailPattern,
//   dispatchtoast,

// } from "../../../utils";
// import { userRegister } from "../../../ApiServices/Apifun";
// import dayjs from "dayjs";
// import { useNavigate } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
// import CommonInput from "../../../Common/CommonInput";
// import { images } from "../../../assets/images";




// const Register = () => {
//   const formRef = useRef();
//   const [form] = Form.useForm();
//   const [membercustomPayload, setCustomMemberPayload] = useState({});
//   const [country, setCountry] = useState([]);
//   const [loader, setloader] = useState(false);
//   const [state, setState] = useState([]);
//   const [city, setCity] = useState([]);
//   const [packages, setPackages] = useState([]);
//   //   const [selectedMember, setSelectedMember] = useState(null);
//   const [memberType, setMemberType] = useState([]);
//   const profiledetail = useSelector((state) => state.B2B.profileDetail);
//   const dispatch = useDispatch();
//   const navigate = useNavigate();

//   const handleFinish = (val) => {
//     // Prepare the payload as a JSON object
//     const payload = {
//       mobile_number: val.mobile_number,
//       email: val.email,
//       name: val.name,
//       password: val.password,
//     };

//     // Call the API with JSON data
//     userRegister(payload)
//       .then((res) => {
//         if (res.status) {
//           dispatchtoast(res.message); // Display success message
//           setloader(false)
//           navigate("/"); // Redirect to home page
//         }
//         else {
//           setloader(true)
//         }
//       })
//       .catch((err) => { console.error(err); setloader(false) }); // Handle error
//   };
//   return (
//     <>
//       <div className=" bg-blue-100 h-screen ">
//         <div className="grid grid-cols-1 md:grid-cols-2  w-full h-screen md:h-full  place-items-center">
//           <div className="h-full      w-full px-10 flex flex-col justify-center items-center">
//             <div className="flex justify-center items-center">
//               <img
//                 src={images.WebsiteLogo}
//                 style={{ filter: "drop-shadow(0px 1px 2px #cfc5c5)" }}
//               />
//             </div>
//             <p className="text-black mt-10 font-[100] text-4xl">Welcome to</p>
//             <p className="mt-6 text-3xl font-semibold text-black">
//               Restrurant Management
//             </p>
//             <p className="text-xs font-normal text-black mt-4">
//               Bunch of all business solution logic
//             </p>
//             <img
//               src={images.login}
//               className="w-[300px] h-[200px] mt-4 m-4"
//             />
//           </div>
//           <div className="bg-gray-100 p-8 h-screen  overflow-y-scroll shadow-lg shadow-gray-500 rounded-md">
//             {/* <div className="flex justify-center items-center">
//       <img
//                 src={Images.WebsiteLogo}
//                 style={{ filter: "drop-shadow(0px 1px 2px #cfc5c5)" }}
//               />
//       </div> */}
//             <div className="p-4 ">
//               <Form
//                 form={form}
//                 ref={formRef}
//                 name="basic"
//                 initialValues={{
//                   remember: true,
//                 }}
//                 onFinishFailed={(err) => console.log(err)}
//                 onFinish={(val) => handleFinish(val)}
//               >
//                 {/* <p className="text-md text-primary font-semibold">Add Member</p> */}
//                 <p className="mt-4 font-semibold">Member Details</p>
//                 <div className="grid xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-2 gap-x-5">
//                   <Form.Item
//                     name={`name`}
//                     label={"Name"}
//                     labelCol={{ span: 24 }}
//                     rules={[
//                       {
//                         required: true,
//                         message: "Enter Name!",
//                       },
//                       {
//                         whitespace: true,
//                         message: "Field cannot contain only blank spaces",
//                       },
//                     ]}
//                   >
//                     <CommonInput
//                       placeholder="Enter Your Name"
//                       name="name"
//                     />
//                   </Form.Item>

//                   <Form.Item
//                     name={`mobile_number`}
//                     label={"Mobile"}
//                     labelCol={{ span: 24 }}
//                     rules={[
//                       {
//                         required: true,
//                         message: "Enter your Mobile Number!",
//                       },
//                       {
//                         pattern: mobilePattern,
//                         message: "Invalid mobile number!",
//                       },
//                       {
//                         whitespace: true,
//                         message: "Field cannot contain only blank spaces",
//                       },
//                     ]}
//                   >
//                     <CommonInput
//                       placeholder="Enter Your Mobile"
//                       name="mobile_number"
//                     />
//                   </Form.Item>{" "}
//                   <Form.Item
//                     name={`email`}
//                     label={"Email"}
//                     labelCol={{ span: 24 }}
//                     rules={[
//                       {
//                         required: true,
//                         message: "Enter your Email!",
//                       },
//                       {
//                         pattern: emailPattern,
//                         message: "Enter Valid Email!",
//                       },
//                       {
//                         whitespace: true,
//                         message: "Field cannot contain only blank spaces",
//                       },
//                     ]}
//                   >
//                     <CommonInput
//                       placeholder="Enter Your Email "
//                       name="email"
//                     />
//                   </Form.Item>{" "}
//                   <Form.Item
//                     name={`password`}
//                     label={"Password"}
//                     labelCol={{ span: 24 }}
//                     rules={[
//                       {
//                         required: true,
//                         message: "Enter Password!",
//                       },
//                       {
//                         // pattern: pincodePattern,
//                         message: "Invalid Password format!",
//                       },
//                       {
//                         whitespace: true,
//                         message: "Field cannot contain only blank spaces",
//                       },
//                     ]}
//                   >
//                     <CommonInput
//                       placeholder="Enter Your Password"
//                       name="password"
//                     />
//                   </Form.Item>



//                 </div>

//                 <div className="flex justify-start items-center mt-2">
//                   <Form.Item>
//                     <Button
//                       loading={loader}
//                       htmlType="submit"
//                       className="bg-primary outline-none border-none text-white"
//                     >
//                       Save
//                     </Button>
//                   </Form.Item>
//                 </div>
//               </Form>
//             </div>
//           </div>
//         </div>
//       </div>

//     </>
//   );
// };

// export default Register;


import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { message } from "antd";
import { setLocalStorageItem } from "../../../utils";
import { resendOtp, vendorRegister, verifyOtp } from "../../../ApiServices/Apifun";
import { images } from "../../../assets/images";

const initialForm = {
  name: "",
  email: "",
  mobile_number: "",
  password: "",
  dob: "",
};

// ---- Brand tokens (DineValts) ----
const GOLD = "#C9A227";
const CHARCOAL = "#17140F";

// ---- Small inline icons (no extra dependency needed) ----
const IconUser = (props) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" {...props}>
    <circle cx="12" cy="8" r="3.5" />
    <path d="M4.5 20c1.6-3.6 4.6-5.5 7.5-5.5s5.9 1.9 7.5 5.5" strokeLinecap="round" />
  </svg>
);
const IconMail = (props) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" {...props}>
    <rect x="3.5" y="5.5" width="17" height="13" rx="2" />
    <path d="M4.5 7l7.5 6 7.5-6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
const IconPhone = (props) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" {...props}>
    <path
      d="M6 3.5h2.3l1.2 4-2 1.3a11 11 0 0 0 5.7 5.7l1.3-2 4 1.2V16a2 2 0 0 1-2.2 2A15 15 0 0 1 4 4.7 2 2 0 0 1 6 3.5Z"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const IconLock = (props) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" {...props}>
    <rect x="4.5" y="10.5" width="15" height="9.5" rx="2" />
    <path d="M7.5 10.5V7.5a4.5 4.5 0 0 1 9 0v3" strokeLinecap="round" />
  </svg>
);
const IconCalendar = (props) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" {...props}>
    <rect x="3.5" y="5" width="17" height="15" rx="2" />
    <path d="M3.5 9.5h17M8 3v3.5M16 3v3.5" strokeLinecap="round" />
  </svg>
);
const IconArrowLeft = (props) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" {...props}>
    <path d="M15 5 8 12l7 7" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

function FieldShell({ label, error, icon, children }) {
  return (
    <div className="mb-4">
      <label className="block text-xs font-semibold tracking-wide uppercase text-[#6B6353] mb-1.5">
        {label}
      </label>
      <div className="relative">
        <span className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-[#B8AE93]">
          {icon}
        </span>
        {children}
      </div>
      {error && <p className="text-xs text-red-500 mt-1.5">{error}</p>}
    </div>
  );
}

const inputBase =
  "w-full pl-10 pr-3 py-2.5 border rounded-lg text-sm text-[#231F18] bg-[#FCFAF4] outline-none transition-colors focus:ring-2 focus:ring-[#C9A227]/40 focus:border-[#C9A227] placeholder:text-[#B8AE93]";

export default function VendorRegister() {
  const navigate = useNavigate();

  const [step, setStep] = useState("register"); // 'register' | 'verify'
  const [userData, setUserData] = useState(initialForm);
  const [errors, setErrors] = useState({});

  const [loading, setLoading] = useState(false); // register button
  const [otpLoading, setOtpLoading] = useState(false); // verify button
  const [resendLoading, setResendLoading] = useState(false);

  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const otpRefs = useRef([]);
  const [cooldown, setCooldown] = useState(0);

  useEffect(() => {
    if (cooldown <= 0) return;
    const timer = setTimeout(() => setCooldown((c) => c - 1), 1000);
    return () => clearTimeout(timer);
  }, [cooldown]);

  const startCooldown = () => setCooldown(30);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserData((prev) => ({ ...prev, [name]: value }));
  };

  const validateRegisterForm = () => {
    const newErrors = {};
    if (!userData.name.trim()) newErrors.name = "Name is required";
    if (!/^\S+@\S+\.\S+$/.test(userData.email))
      newErrors.email = "Enter a valid email";
    if (!/^\d{10}$/.test(userData.mobile_number))
      newErrors.mobile_number = "Enter a valid 10 digit mobile number";
    if (userData.password.length < 8)
      newErrors.password = "Password must be at least 8 characters";
    if (!userData.dob) newErrors.dob = "Date of birth is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // ---------------- REGISTER ----------------
  const handleRegister = (e) => {
    e.preventDefault();
    if (!validateRegisterForm()) return;

    setLoading(true);
    const data = {
      name: userData.name,
      email: userData.email,
      mobile_number: userData.mobile_number,
      password: userData.password,
      dob: userData.dob,
    };

    vendorRegister(data)
      .then((response) => {
        if (response.status) {
          message.success(response.message || "OTP sent to your email");
          setStep("verify");
          startCooldown();
        } else {
          message.error(response.message || "Registration failed");
        }
      })
      .catch((error) => {
        console.log(error);
        message.error(
          error?.response?.data?.message || "Something went wrong"
        );
      })
      .finally(() => setLoading(false));
  };

  // ---------------- VERIFY OTP ----------------
  const handleOtpChange = (idx, value) => {
    const digit = value.replace(/\D/g, "").slice(-1);
    setOtp((prev) => {
      const next = [...prev];
      next[idx] = digit;
      return next;
    });
    if (digit && idx < 5) otpRefs.current[idx + 1]?.focus();
  };

  const handleOtpKeyDown = (idx, e) => {
    if (e.key === "Backspace" && !otp[idx] && idx > 0) {
      otpRefs.current[idx - 1]?.focus();
    }
  };

  const handleOtpPaste = (e) => {
    const text = e.clipboardData.getData("text").replace(/\D/g, "").slice(0, 6);
    if (!text) return;
    e.preventDefault();
    setOtp((prev) => {
      const next = [...prev];
      for (let i = 0; i < 6; i++) next[i] = text[i] || next[i];
      return next;
    });
    otpRefs.current[Math.min(text.length, 5)]?.focus();
  };

  const handleVerifyOtp = (e) => {
    e.preventDefault();
    const code = otp.join("");
    if (code.length !== 6) {
      message.error("Please enter complete 6 digit OTP");
      return;
    }

    setOtpLoading(true);
    const data = { email: userData.email, otp: code };

    verifyOtp(data)
      .then((response) => {
        if (response.status) {
          setLocalStorageItem("token_vendor", response.data?.access_token);
          setLocalStorageItem("user", response.data?.user);
          setLocalStorageItem("wallet", response.data?.walletBalance);
          setLocalStorageItem("login", true);
          message.success("Vendor Registered Successfully");
          navigate("/dashboard");
        } else {
          message.error(response.message || "Invalid OTP");
        }
      })
      .catch((error) => {
        console.log(error);
        message.error(
          error?.response?.data?.message || "OTP verification failed"
        );
      })
      .finally(() => setOtpLoading(false));
  };

  // ---------------- RESEND OTP ----------------
  const handleResendOtp = () => {
    if (cooldown > 0) return;

    setResendLoading(true);
    resendOtp({ email: userData.email })
      .then((response) => {
        if (response.status) {
          message.success("OTP resent successfully");
          startCooldown();
        } else {
          message.error(response.message || "Failed to resend OTP");
        }
      })
      .catch((error) => {
        console.log(error);
        message.error(
          error?.response?.data?.message || "Failed to resend OTP"
        );
      })
      .finally(() => setResendLoading(false));
  };

  return (
    <div className="min-h-screen w-full lg:grid lg:grid-cols-2 bg-[#FCFAF4]">
      {/* ---------- Left / brand panel (hidden on mobile) ---------- */}
      <div
        className="hidden lg:flex flex-col justify-between p-12 relative overflow-hidden"
        style={{ backgroundColor: CHARCOAL }}
      >
        <div
          className="pointer-events-none absolute -right-24 -top-24 w-[420px] h-[420px] rounded-full opacity-[0.07]"
          style={{ border: `1px solid ${GOLD}` }}
        />
        <div
          className="pointer-events-none absolute -right-10 top-40 w-[300px] h-[300px] rounded-full opacity-[0.09]"
          style={{ border: `1px solid ${GOLD}` }}
        />

        <img
          src={images.Logo}
          alt="DineValts"
          className="w-[140px] rounded-lg object-cover"
        />

        <div className="relative">
          <p className="font-serif text-3xl leading-snug text-[#F7F3E9] max-w-sm">
            Bring your restaurant onto DineValts.
          </p>
          <p className="mt-4 text-sm text-[#C7BFA9] max-w-sm leading-relaxed">
            Manage your menu, orders and payouts from one vendor dashboard —
            built for restaurants that care about the details.
          </p>
        </div>

        <p className="relative text-[11px] tracking-[0.2em] uppercase text-[#8A8062]">
          © {new Date().getFullYear()} DineValts · Vendor Network
        </p>
      </div>

      {/* ---------- Right / form panel ---------- */}
      <div className="flex items-center justify-center px-4 py-10 sm:py-14">
        <div className="w-full max-w-md">
          <div className="mb-6 lg:hidden flex justify-center">
            <img
              src={images.Logo}
              alt="DineValts"
              className="w-[150px] rounded-lg object-cover"
            />
          </div>

          <div className="text-center lg:text-left mb-7">
            <span
              className="inline-block text-[11px] font-semibold tracking-[0.2em] uppercase mb-2"
              style={{ color: GOLD }}
            >
              {step === "register" ? "Step 1 of 2 · Details" : "Step 2 of 2 · Verification"}
            </span>
            <h1 className="font-serif text-[1.65rem] text-[#17140F]">
              {step === "register" ? "Register your restaurant" : "Confirm it's you"}
            </h1>
            <p className="text-sm text-[#6B6353] mt-1.5">
              {step === "register"
                ? "Tell us a bit about you to open your vendor account."
                : `We sent a 6-digit code to ${userData.email}`}
            </p>
          </div>

          <div className="bg-white border border-[#EDE6D3] rounded-2xl shadow-[0_1px_2px_rgba(23,20,15,0.04)] p-6 sm:p-7">
            {step === "register" && (
              <form onSubmit={handleRegister} noValidate>
                <FieldShell label="Full name" error={errors.name} icon={<IconUser className="w-4 h-4" />}>
                  <input
                    type="text"
                    name="name"
                    value={userData.name}
                    onChange={handleChange}
                    placeholder="Vijay Pareek"
                    className={`${inputBase} ${errors.name ? "border-red-400" : "border-[#E6DFC9]"}`}
                  />
                </FieldShell>

                <FieldShell label="Email" error={errors.email} icon={<IconMail className="w-4 h-4" />}>
                  <input
                    type="email"
                    name="email"
                    value={userData.email}
                    onChange={handleChange}
                    placeholder="you@example.com"
                    className={`${inputBase} ${errors.email ? "border-red-400" : "border-[#E6DFC9]"}`}
                  />
                </FieldShell>

                <FieldShell
                  label="Mobile number"
                  error={errors.mobile_number}
                  icon={<IconPhone className="w-4 h-4" />}
                >
                  <input
                    type="tel"
                    name="mobile_number"
                    value={userData.mobile_number}
                    onChange={(e) =>
                      handleChange({
                        target: {
                          name: "mobile_number",
                          value: e.target.value.replace(/\D/g, "").slice(0, 10),
                        },
                      })
                    }
                    placeholder="9876543210"
                    className={`${inputBase} ${errors.mobile_number ? "border-red-400" : "border-[#E6DFC9]"}`}
                  />
                </FieldShell>

                <FieldShell label="Password" error={errors.password} icon={<IconLock className="w-4 h-4" />}>
                  <input
                    type="password"
                    name="password"
                    value={userData.password}
                    onChange={handleChange}
                    placeholder="At least 8 characters"
                    className={`${inputBase} ${errors.password ? "border-red-400" : "border-[#E6DFC9]"}`}
                  />
                </FieldShell>

                <FieldShell label="Date of birth" error={errors.dob} icon={<IconCalendar className="w-4 h-4" />}>
                  <input
                    type="date"
                    name="dob"
                    value={userData.dob}
                    onChange={handleChange}
                    className={`${inputBase} ${errors.dob ? "border-red-400" : "border-[#E6DFC9]"}`}
                  />
                </FieldShell>

                <button
                  type="submit"
                  disabled={loading}
                  className="w-full mt-2 py-2.5 rounded-lg text-sm font-semibold text-[#17140F] bg-[#C9A227] hover:bg-[#B8931F] disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                >
                  {loading ? "Creating account…" : "Create account"}
                </button>

                <p className="text-center text-xs text-[#9C9584] mt-4">
                  Already registered?{" "}
                  <span
                    className="font-semibold cursor-pointer hover:underline"
                    style={{ color: GOLD }}
                    onClick={() => navigate("/login")}
                  >
                    Sign in
                  </span>
                </p>
              </form>
            )}

            {step === "verify" && (
              <form onSubmit={handleVerifyOtp}>
                <div onPaste={handleOtpPaste} className="flex justify-between gap-2 mb-2">
                  {otp.map((digit, idx) => (
                    <input
                      key={idx}
                      ref={(el) => (otpRefs.current[idx] = el)}
                      value={digit}
                      onChange={(e) => handleOtpChange(idx, e.target.value)}
                      onKeyDown={(e) => handleOtpKeyDown(idx, e)}
                      inputMode="numeric"
                      maxLength={1}
                      className={`w-11 h-12 text-center text-lg font-semibold rounded-lg outline-none bg-[#FCFAF4] border transition-colors focus:ring-2 focus:ring-[#C9A227]/40 focus:border-[#C9A227] ${digit ? "border-[#C9A227]" : "border-[#E6DFC9]"
                        }`}
                    />
                  ))}
                </div>

                <p className="text-xs text-[#9C9584] mb-6">
                  Didn't get it? Check spam, or resend below.
                </p>

                <button
                  type="submit"
                  disabled={otpLoading}
                  className="w-full py-2.5 rounded-lg text-sm font-semibold text-[#17140F] bg-[#C9A227] hover:bg-[#B8931F] disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                >
                  {otpLoading ? "Verifying…" : "Verify & continue"}
                </button>

                <div className="flex items-center justify-between mt-4">
                  <button
                    type="button"
                    onClick={() => setStep("register")}
                    className="inline-flex items-center gap-1 text-sm text-[#6B6353] hover:text-[#17140F]"
                  >
                    <IconArrowLeft className="w-3.5 h-3.5" />
                    Edit details
                  </button>

                  <button
                    type="button"
                    onClick={handleResendOtp}
                    disabled={cooldown > 0 || resendLoading}
                    className={`text-sm font-semibold ${cooldown > 0 || resendLoading
                      ? "text-[#B8AE93] cursor-not-allowed"
                      : "hover:underline"
                      }`}
                    style={{ color: cooldown > 0 || resendLoading ? undefined : GOLD }}
                  >
                    {resendLoading
                      ? "Resending…"
                      : cooldown > 0
                        ? `Resend OTP (${cooldown}s)`
                        : "Resend OTP"}
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}